export default {
  getStartedButton: {
    id: 'merchant_onboarding_home_welcome_modal_get_started_button',
    defaultMessage: 'Let’s get started',
  },
  modalTitle: {
    id: 'merchant_onboarding_home_welcome_modal_title',
    defaultMessage: 'Welcome to Back Market!',
  },
  modalBodyTitle: {
    id: 'merchant_onboarding_home_welcome_modal_body_title',
    defaultMessage: 'A note from the founders',
  },
  modalBodyDescription1: {
    id: 'merchant_onboarding_home_welcome_modal_body_description_first_part',
    defaultMessage:
      'Thanks for joining Back Market. Our goal is to help you maximize your business while minimizing your effort.',
  },
  modalBodyDescription2: {
    id: 'merchant_onboarding_home_welcome_modal_body_description_second_part',
    defaultMessage:
      'Because, as mushy as it sounds, we care. And because we’re committed to high-quality standards that will prove once and for all that renewed tech doesn’t mean second-rate.',
  },
  imageAlt: {
    id: 'merchant_onboarding_home_welcome_modal_body_image_alt',
    defaultMessage: 'Founders picture',
  },
}
